import { FC, useState } from "react";
import { Cart, Container, TextCart } from "./style";
import login from "assets/images/new-logo.svg";
import message from "assets/images/message.svg";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { useNavigate } from "react-router-dom";
import useForget from "../reset-password/useHook";
import Swal from "sweetalert2";
import Spinner from "components/particles/loaders/spinner";

const CheckMail: FC = () => {
  const navigate = useNavigate();
  const { forget } = useForget();
  const [isLoading, setIsLoading] = useState(false);

  const resendEmail = async () => {
    setIsLoading(true);
    const tempEmail = localStorage.getItem("tempEmail");
    console.log(tempEmail);
    if (!tempEmail) {
      setIsLoading(false);
      return;
    }

    const response = await forget({ email: tempEmail });
    setIsLoading(false);

    if (response?.success === false) return;

    Swal.fire({
      icon: "success",
      title: "Success",
      text: "Email sent successfully",
      showConfirmButton: false,
      timer: 1500,
    });
  };

  return (
    <Container>
      <Cart>
        <img style={{ width: "100px", height: "100px" }} src={login} alt="img" />
        <div className="forget-cart-data">
          <img src={message} alt="img" width={150} />
          <div className="chack-mail-data">
            <h1>Check your Email</h1>
            <p>
              Thank you, check your email for instructions to reset your
              password
            </p>
          </div>
        </div>
        <TextCart>
          <div className="receive-email-text">
            Don’t receive an email?
            <span className="receive-resend-text" onClick={resendEmail}>
              {isLoading ? <Spinner /> : "Resend"}
            </span>
          </div>
          <div className="back-to-sign-in-cart">
            <span
              className="back-to-sign-in"
              onClick={() => navigate(siteRoutes.login)}
            >
              Back to Sign In
            </span>
          </div>
        </TextCart>
      </Cart>
    </Container>
  );
};

export default CheckMail;
